// Client-side CSV/JSON building + download for a pattern's exported threads. Kept free of
// React so it's trivially testable and reusable from any trigger (button, menu, etc.).

const CSV_COLUMNS = [
  { key: 'thread_id', label: 'Conversation ID' },
  { key: 'email', label: 'Email' },
  { key: 'user_id', label: 'User ID' },
  { key: 'start_at', label: 'Start at' },
  { key: 'lifecycle_state', label: 'Lifecycle state' },
  { key: 'activity_state', label: 'Activity state' },
  { key: 'actionability', label: 'Actionability' },
  { key: 'representative_quote', label: 'Representative quote' },
  { key: 'classification_rationale', label: 'Classification rationale' },
];

// Prevents CSV/formula injection: a field whose first meaningful character is =, +, -, or @
// gets interpreted as a formula by Excel/Sheets when the export is opened. Quotes/
// rationale are LLM-generated free text, not something we control the shape of. A bare \r
// (without \n) is also treated as a line break requiring quoting — otherwise it can act as
// an unquoted row separator in some spreadsheet apps, letting `safe\r=HYPERLINK(...)` start
// a new "row" whose content bypasses the leading-character check above.
const escapeCsvField = (value) => {
  let str = value == null ? '' : String(value);
  if (/^\s*[=+\-@]/.test(str)) str = `'${str}`;
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

// Keeps filenames filesystem-safe across OSes without pulling in a slugify dependency.
const sanitizeFilenamePart = (value) => {
  const slug = (value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  return slug || 'pattern';
};

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadPatternMetadataCsv = (pattern, threads) => {
  const header = CSV_COLUMNS.map((c) => escapeCsvField(c.label)).join(',');
  const rows = threads.map((t) => CSV_COLUMNS.map((c) => escapeCsvField(t[c.key])).join(','));
  const blob = new Blob([[header, ...rows].join('\n')], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, `livechat-mining-${sanitizeFilenamePart(pattern)}.csv`);
};

export const downloadPatternConversationsJson = (pattern, threads) => {
  const blob = new Blob([JSON.stringify(threads, null, 2)], { type: 'application/json' });
  downloadBlob(blob, `livechat-mining-${sanitizeFilenamePart(pattern)}-conversations.json`);
};
